<template>
	<el-card shadow="never">
		<div class="header-row" slot="header">
			<div class="title">
				<span style="margin-right: 10px">工单信息</span>
			</div>
		</div>
		<div class="workorder-list">
			<el-empty v-if="!workorders.length" description="暂无工单信息" />
			<!-- <div class="workorder-item" v-else v-for="(order, index) in workorders" :key="index">
				<div class="content-wrapper">
					<div class="title-text">{{ order.content }}</div>
					<div class="description">
						<span>接收时间：</span>
						<span>{{ order.receiveTime }}</span>
					</div>
				</div>
				<div>
					<div class="tags">
						<el-tag size="mini" :type="getPriorityType(order.type)">{{ order.type }}</el-tag>
					</div>
					<div class="tags">
						<el-tag size="mini" :type="getStatusType(order.status)">{{ order.status }}</el-tag>
					</div>
				</div>
			</div> -->
			<div class="workorder-table">
				<!-- 表头 -->
				<div class="header">
					<div class="col content">故障描述</div>
					<div class="col time">上报时间</div>
					<div class="col">故障类型</div>
					<div class="col">状态</div>
				</div>

				<div class="rows">
					<!-- 数据 -->
					<div class="row" v-for="(order, index) in workorders" :key="index">
						<div class="col content row-content">
							<div class="title-text">{{ order.content }}</div>
						</div>

						<div class="col time row-time">
							{{ order.receiveTime }}
						</div>

						<div class="col">
							<el-tag size="mini" :type="getPriorityType(order.type)">
								{{ order.type }}
							</el-tag>
						</div>

						<div class="col">
							<el-tag size="mini" :type="getStatusType(order.status)">
								{{ order.status }}
							</el-tag>
						</div>
					</div>
				</div>
			</div>
		</div>
	</el-card>
</template>

<script>
	import { getHomeWorkInfo } from '@/api/home/homeApi.js';
	export default {
		name: 'WorkOrderInfo',
		data() {
			return {
				workorders: [],
			};
		},
		computed: {
			// 计算待处理工单数量
			pendingCount() {
				return this.workorders.filter(order => order.status === '待处理').length;
			},
		},
		created() {
			this.fetchWorkOrders();
		},
		methods: {
			async fetchWorkOrders() {
				const { data } = await getHomeWorkInfo();
				this.workorders = data.workItems || [];
			},
			getPriorityType(priority) {
				const map = {
					资产盘点: 'danger',
					合同续签: 'warning',
					设备维护: 'success',
					租金催收: 'primary',
				};
				return map[priority] || 'info';
			},
			getStatusType(desc) {
				const map = {
					紧急: 'warning',
					处理中: 'primary',
					待处理: 'danger',
				};
				return map[desc] || 'info';
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.el-card__body) {
		height: 214px;
	}

	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}
	.title {
		font-weight: bold;
	}

	.workorder-list {
		width: 100%;
		height: 100%;
	}

	.workorder-table {
		width: 100%;
		height: 100%;
		font-size: 14px;
	}

	.header {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f1f5f9;
		height: 40px;
		font-weight: 500;
		font-size: 12px;
		color: rgba(0, 0, 0, 0.4);
		line-height: 40px;
	}

	.rows {
		height: calc(100% - 40px);
		overflow-y: auto;
		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background: #bfbfbf;
			border-radius: 4px;
			transition: background 0.3s;

			&:hover {
				background: #999;
			}
		}
	}

	.row {
		display: flex;
		align-items: center;
		// padding: 10px 0;
		height: calc(100% / 3 - 1px);
		border-bottom: 1px solid #f1f5f9;
	}

	.col {
		flex: 1;
		padding: 0 10px;
		box-sizing: border-box;
		color: rgba(0, 0, 0, 0.4);
		font-size: 12px;
	}

	.content {
		flex: 2;
	}

	.time {
		flex: 1.5;
	}

	.row-content {
		font-size: 14px;
		color: #0f172a;
		font-weight: bold;
	}

	.row-time {
		font-weight: 400;
		font-size: 14px;
		color: rgba(0, 0, 0, 0.8);
	}

	/* 文本省略 */
	.title-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
